module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/catasto_big_freccia.6e5c35de.png";